import PropTypes from 'prop-types'
import { positionPropType } from '../common/position-prop-type'
import { idPropType } from '../common/id-prop-type'

/**
 * @typedef {Object} Route
 *
 * @property {Id} [addressId] - id of the address of the waypoint
 * @property {string} [locationDescription] - description of the location
 * @property {Position} position - position of the waypoint
 * @property {boolean} [viaWaypoint] - whether this is a via waypoint of a final waypoint
 */
export const waypointsPropType = PropTypes.shape({
    addressId: idPropType,
    locationDescription: PropTypes.string,
    position: positionPropType.isRequired,
    viaWaypoint: PropTypes.bool
})
